<template>
     <div class="posts-box has-cat has-load-more">
                        <div class="posts-box__top">
                            <h4 class="posts-box__top__title">Najčitanije</h4>
                            <!-- <div class="posts-box__category">
                                <div class="flex-menu-parent">
                                    <ul class="menu flex">
                                        <li class="active"><a href="#">Sports</a></li>
                                        <li><a href="#">World</a></li>
                                        <li><a href="#">Entertainment</a></li>
                                        <li><a href="#">Local</a></li>
                                        <li><a href="#">Technology</a></li>
                                    </ul>
                                </div>
                            </div> -->
                        </div>

                        <div class="posts-list has-style-1">

                            <article v-for="(post, i) in posts" :key="i" class="post-item cat-business post-item--style-1">
                                <figure>
                                <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}"><img v-lazy="post.absolutePhotoUrl" v-bind:alt="post.title"></router-link>
                                </figure>
                                <div class="post-content">
                                    <div class="post-category">
                                        <ul>
                                            <li> <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}" v-bind:style="{background: post.categoryBorderColor }">{{post.category}}</router-link></li>
                                        </ul>
                                    </div>
                                    <h4 class="post-title"> <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">{{ post.shortTitle? post.shortTitle : post.title }}</router-link></h4>
                                    <div class="post-meta">
                                        <time ><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }}</time>
                                    </div>
                                    <p class="post-excerpt">
                                        {{ post.intro.length > 100? post.intro.substring(0,100) + "..." : post.intro }}
                                    </p>
                                </div>
                            </article>
                        </div><!--//.posts-list -->

                        <div class="posts-box__bottom">
                        </div>
                    </div> <!--//.posts-box  -->
</template>

<script>
    import { NewsService } from '../common/api.service'

    export default {
        name: "PopularBox",
        data() {
            return {
                posts: []
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {
                NewsService.getPopular(4, 30, null).then(res => this.posts = res.data);
            }
        }
    }
</script>

<style scoped>
    img {
        object-fit: cover;
        width: 100%;
        height: 24vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/PopularBox.vue